import { WZ_QUANTITY_INVALID_CODE } from './warehouseQuantity';

/**
 * Single home for the WZ backend-validation-string -> wz:serverErrors.* key
 * map, consumed via getApiErrorMessage (utils/apiError.ts).
 *
 * Backend WZ validation strings are hardcoded English (no backend i18n).
 * Every caller of getApiErrorMessage for a WZ-related request MUST pass this
 * map — omitting it silently downgrades a Polish-first surface to raw
 * English for any error covered here (this happened once already: OrderDetail.tsx's
 * "Generuj WZ" action rendered English validation errors while WZNew.tsx's
 * identical picker action, calling the same backend endpoint, rendered
 * Polish). Unmapped strings fall through to the raw text — no silent loss,
 * just no translation.
 */
export const WZ_SERVER_ERROR_KEYS: Record<string, string> = {
  [WZ_QUANTITY_INVALID_CODE]: 'wz:serverErrors.quantityPrecision',
  'Order ID is required': 'wz:serverErrors.orderRequired',
  'Release date is required': 'wz:serverErrors.releaseDateRequired',
  // Route-layer (express-validator) variant of the same field — different wording.
  'Valid release date is required': 'wz:serverErrors.releaseDateRequired',
  'Issuer name is required': 'wz:serverErrors.issuerNameRequired',
  'Issuer address is required': 'wz:serverErrors.issuerAddressRequired',
  'Recipient name is required': 'wz:serverErrors.recipientNameRequired',
  'Recipient address is required': 'wz:serverErrors.recipientAddressRequired',
  'Issued by person is required': 'wz:serverErrors.issuedByRequired',
  'Issued by person must be at most 100 characters': 'wz:serverErrors.personNameMax',
  'Received by person must be at most 100 characters': 'wz:serverErrors.personNameMax',
  'At least one item is required': 'wz:serverErrors.itemsRequired',
  // WZ_ORDER_FULLY_COVERED is handled separately (showWZFullyCoveredConfirm)
  // — it needs the blocking document numbers/statuses interpolated and a
  // confirm action, which this static code -> key map cannot express. See
  // wzOrderFullyCoveredMessage.ts.
};
